import { Routes } from '@angular/router';

export const routes: Routes = [
  { path: '', redirectTo: 'login', pathMatch: 'full' },
  {
    path: 'login',
    loadComponent: () =>
      import('./users/login/login.component').then((x) => x.LoginComponent),
  },
  {
    path: 'forgot-password',
    loadComponent: () =>
      import('./users/forgot-password/forgot-password.component').then(
        (x) => x.ForgotPasswordComponent
      ),
  },
  {
    path: 'main-template',
    loadComponent: () =>
      import('./main-template/main-template.component').then(
        (x) => x.MainTemplateComponent
      ),
    children: [
      {
        path: '',
        redirectTo: 'claim-management',
        pathMatch: 'full',
      },
      {
        path: 'claim-management',
        children: [
          {
            path: '',
            redirectTo: 'claims',
            pathMatch: 'full',
          },
          {
            path: 'claims',
            loadComponent: () =>
              import('./claims/claims-list/claims-list.component').then(
                (m) => m.ClaimsListComponent
              ),
          },
          {
            path: 'add-claim',
            loadComponent: () =>
              import('./claims/add-claim/add-claim.component').then(
                (m) => m.AddClaimComponent
              ),
          },
          {
            path: 'add-claim/:Id',
            loadComponent: () =>
              import('./claims/add-claim/add-claim.component').then(
                (m) => m.AddClaimComponent
              ),
          },

          {
            path: 'tasks',
            loadComponent: () =>
              import('./tasks/tasks-list/tasks-list.component').then(
                (m) => m.TasksListComponent
              ),
          },
        ],
      },
      {
        path: 'operations',
        children: [
          {
            path: 'tasks',
            loadComponent: () =>
              import(
                './operations/operations-home/operations-home.component'
              ).then((m) => m.OperationsHomeComponent),
          },
        ],
      },
      {
        path: 'settlements',
        children: [
          {
            path: 'facility-settlement',
            loadComponent: () =>
              import(
                './facility-settlement/facility-settlement-list/facility-settlement-list.component'
              ).then((m) => m.FacilitySettlementListComponent),
          },
          {
            path: 'insurer-settlement',
            loadComponent: () =>
              import(
                './insurer-settlement/insurer-settlement-list/insurer-settlement-list.component'
              ).then((m) => m.InsurerSettlementListComponent),
          },
          {
            path: 'claim-closure',
            loadComponent: () =>
              import(
                './claim-closure/claim-closure-list/claim-closure-list.component'
              ).then((m) => m.ClaimClosureListComponent),
          },
          {
            path: 'unpaid-claims',
            loadComponent: () =>
              import(
                './unpaid-claim/unpaid-claims-list/unpaid-claims-list.component'
              ).then((m) => m.UnpaidClaimsListComponent),
          },
        ],
      },
      {
        path: 'settings',
        children: [
          {
            path: '',
            redirectTo: 'routes',
            pathMatch: 'full',
          },
          {
            path: 'routes',
            loadComponent: () =>
              import('./routes/routes-list/routes-list.component').then(
                (m) => m.RoutesListComponent
              ),
          },
          {
            path: 'insurance-companies',
            loadComponent: () =>
              import('./settings/insurance-companies/insurer-company-list/insurance-companies-list.component').then(
                (m) => m.InsuranceCompaniesListComponent
              ),
          },
          {
            path: 'insurance-companies/add',
            loadComponent: () =>
              import('./settings/insurance-companies/add-insurer-company/insurance-company-add.component').then(
                (m) => m.InsuranceCompanyAddComponent
              ),
          },
          {
            path: 'facilities',
            loadComponent: () =>
              import('./settings/facilities/facility-list/facility-list.component').then(
                (m) => m.FacilityListComponent
              ),
          },
          {
            path: 'facilities/add',
            loadComponent: () =>
              import('./settings/facilities/add-facility/add-facility.component').then(
                (m) => m.AddFacilityComponent
              ),
          },
          {
            path: 'tpa-insurer-contracts',
            loadComponent: () =>
              import('./settings/tpa-insurer-contract/tpa-insurer-contract-list/tpa-insurer-contract-list.component').then(
                (m) => m.TpaInsurerContractListComponent
              ),
          },
          {
            path: 'tpa-insurer-contracts/add',
            loadComponent: () =>
              import('./settings/tpa-insurer-contract/tpa-insurer-contract-add/tpa-insurer-contract-add.component').then(
                (m) => m.TpaInsurerContractAddComponent
              ),
          },
          {
            path: 'car-make-and-model',
            loadComponent: () =>
              import('./settings/car-make-and-model/car-make-and-model-list/car-make-and-model-list.component').then(
                (m) => m.CarMakeAndModelListComponent
              ),
          },
          {
            path: 'car-make-and-model/add',
            loadComponent: () =>
              import('./settings/car-make-and-model/car-make-and-model-add/car-make-and-model-add.component').then(
                (m) => m.CarMakeAndModelAddComponent
              ),
          },
          {
            path: 'add-route',
            loadComponent: () =>
              import('./routes/add-route/add-route.component').then(
                (m) => m.AddRouteComponent
              ),
          },
          {
            path: 'update-route/:id',
            loadComponent: () =>
              import('./routes/add-route/add-route.component').then(
                (m) => m.AddRouteComponent
              ),
          },
        ],
      },
    ],
  },
  {
    path: 'display-pdf/:pdfURL',
    loadComponent: () =>
      import('./core/components/display-pdf/display-pdf.component').then(
        (m) => m.DisplayPdfComponent
      ),
  },
];
